import { CollisionDetection, closestCorners, pointerWithin } from '@dnd-kit/core';
import { DragDropContainerType } from './index';
import { SortableForgeListItem } from './SortableForgeListItem';
import { SortableForgeCardElement } from './SortableForgeCardElement';
import { SortableListElement } from './SortableListElement';
import { SortableTableElement } from './SortableTableElement';
import { SortableConditionElement } from './SortableConditionElement';

// Get the appropriate sortable component based on type
export const getSortableComponent = (type: DragDropContainerType) => {
  switch (type) {
    case DragDropContainerType.FORGE_LIST:
      return SortableForgeListItem;
    case DragDropContainerType.FORGE_CARD:
      return SortableForgeCardElement;
    case DragDropContainerType.LIST:
      return SortableListElement;
    case DragDropContainerType.TABLE:
      return SortableTableElement;
    case DragDropContainerType.CONDITIONS:
      return SortableConditionElement;
    default:
      return SortableListElement;
  }
};

// Custom collision detection optimized for ForgeListItem with wrapper divs
// Otherwise this will always move the item to the last position.
export const customCollisionDetection: CollisionDetection = (args) => {
  // Use pointerWithin first (works better with wrapper divs), fallback to closestCorners
  const pointerWithinResult = pointerWithin(args);
  return pointerWithinResult.length > 0 ? pointerWithinResult : closestCorners(args);
};
